import * as React from 'react'
import { Link as ScrollLink } from 'react-scroll'

interface Props {
	isTopPage: boolean
}

export default class FooterComponent extends React.Component<Props> {
	constructor(props: Props) {
		super(props)
	}

	render() {
		return (
			<div className="footer">
				<div className="row">
					<div className="container-fluid">
						<ul>
							<li>
								{
									this.props.isTopPage ?
									<ScrollLink to="service" smooth={true} duration={640}>SERVICE</ScrollLink>
									: <a href="/#service">SERVICE</a>
								}
							</li>
							<li>
								{
									this.props.isTopPage ?
									<ScrollLink to="works" smooth={true} duration={640}>WORKS</ScrollLink>
									: <a href="/#works">WORKS</a>
								}
							</li>
							<li>
								{
									this.props.isTopPage ?
									<ScrollLink to="clients" smooth={true} duration={640}>OUR CLIENTS</ScrollLink>
									: <a href="/#clients">OUR CLIENTS</a>
								}
							</li>
							<li>
								{
									this.props.isTopPage ?
									<ScrollLink to="company" smooth={true} duration={640}>COMPANY</ScrollLink>
									: <a href="/#company">COMPANY</a>
								}
							</li>
							<li>
								<ScrollLink to="contacts-before" smooth={true} duration={640}>CONTACT</ScrollLink>
							</li>
						</ul>
						<div className="copyright">
							<p className="lisence">© Copyright 2018 GENESIS Co., Ltd.</p>
						</div>
					</div>
				</div>
			</div>
		)
	}
}


// WEBPACK FOOTER //
// ./src/components/common/footerComponent.tsx